<template>
  <div class="product-item mb-3">
    <div class="position-relative">
      <a class="mb-3" @click="onClickProductItem" :href="product.page_url">
        <img :src="product.image_or_brand" :alt="product.name" class="img-fluid">
      </a>
      <small class="d-block mb-1">
        {{ product.brand.name }}
      </small>
      <a class="font-weight-bold product-name d-block mb-1" @click="onClickProductItem" :href="product.page_url">
        {{product.name}}
      </a>
      <small v-if="product.sizes.length > 0" class="text-muted d-block">
        {{ $t('Size available', product.sizes.length) }} : {{ product.sizes.join(', ') }}
      </small>
    </div>
    <slot name="footer" :product="product"></slot>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const { product } = defineProps({
  product: {
    required: true,
  },
})

const emit = defineEmits(['click']);

const onClickProductItem = (e) => {
  emit('click', e);
}

</script>
<style scoped>
.product-item {
    transition: all 0.3s;
}
a.product-name {
  text-decoration: none;
  color: black;
}
</style>